module.exports = {
    UserNotLoggedInError: (function () {
        function UserNotLoggedInError() {
            this.message = message || "User not logged in.";
            Error.captureStackTrace(this);
            this.message = message;
            this.name = "UserNotLoggedInError";
        }
        UserNotLoggedInError.prototype = Object.create(Error.prototype);
        return UserNotLoggedInError;
    }()),
    UnauthorizedError: (function () {
        function UnauthorizedError() {
            this.message = message || "User not authorized.";
            Error.captureStackTrace(this);
            this.message = message;
            this.name = "UnauthorizedError";
        }
        UnauthorizedError.prototype = Object.create(Error.prototype);
        return UnauthorizedError;
    }()),
    InvalidArgumentError: (function () {
        function InvalidArgumentError(arg) {
            Error.captureStackTrace(this);
            this.message = "Argument [" + arg + "] is invalid.";
            this.name = "InvalidArgumentError";
        }
        InvalidArgumentError.prototype = Object.create(Error.prototype);
        return InvalidArgumentError;
    }()),
    ConnectionError: (function () {
        function ConnectionError(detail) {
            this.message = "Connection not established.";
            Error.captureStackTrace(this);
            this.name = "ConnectionError";
        }
        ConnectionError.prototype = Object.create(Error.prototype);
        return ConnectionError;
    }())
};


// WEBPACK FOOTER //
// ./src-client-lib/api/smash-errors.js